export const salesPersonListingConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETALLSALESPERSONLISTING_REQUEST: 'GETALLSALESPERSONLISTING_REQUEST',
    GETALLSALESPERSONLISTING_REQUEST_END: 'GETALLSALESPERSONLISTING_REQUEST_END',

    GETALLSALESPERSONLISTING_SUCCESS: 'GETALLSALESPERSONLISTING_SUCCESS',
    GETALLSALESPERSONLISTING_FAILURE: 'GETALLSALESPERSONLISTING_FAILURE'
};